import { useEffect, useState } from 'react';
import { listAccessorialTypes, type AccessorialType } from '../../../rate-cards.api';

/** The accessorial catalogue (waiting, escort, …), fetched once: a small fixed list, so no server paging. Inactive types stay, so an old rate still shows its type's name. */
export function useAccessorialTypes(): AccessorialType[] {
  const [types, setTypes] = useState<AccessorialType[]>([]);

  useEffect(() => {
    let cancelled = false;
    listAccessorialTypes()
      .then((all) => {
        if (!cancelled) setTypes(all);
      })
      .catch(() => {
        if (!cancelled) setTypes([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return types;
}
